import React from "react";
import "./Map.css";
import { Home_Map_Data } from "../../../Constant/Data";

const Map = () => {
  const data = Home_Map_Data;
  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div className="wrap_map_image">
        <img
          className="img-fluid z-index-1 map_image"
          src="./images/Map/Map1.png"
        />
      </div>
      {data.map((item) => (
        <a
          data-text={item.hoverText}
          key={item.id}
          className="drag_element tips tooltip_own"
          style={{ top: item.top, left: item.left }}
        >
          <img src={item.imageUrl} className="pins_image ihotspot_hastooltop" />
        </a>
      ))}
    </div>
  );
};

export default Map;
